import { combineReducers } from 'redux';

import { SEARCH, SORT } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import loading from 'modules/global/reducers/generic.loading';
import page from 'modules/global/reducers/generic.page';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import * as types from 'modules/whitelist/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const selectEntryId = entity => entity?.entityId ?? entity?.id ?? entity;

const emptyFiltersState = { [SEARCH]: null, [SORT]: 'createdOn,desc' };

/** @type {import("modules/global/reducers/filterSliceAdapter").FilterAdapter} */
const filterAdapter = filterSliceAdapter(emptyFiltersState);

export default combineReducers({
  page: page(types.FETCH_WHITELIST),
  loading: combineReducers({
    fetching: loading(types.FETCH_WHITELIST),
    deleting: loadingArraySlice(types.DELETE_WHITELIST, { global: { selectId: selectEntryId } }),
  }),
  filters: createReducer(filterAdapter.getInitialState(), {
    [types.SET_FILTER]: filterAdapter.setFilter,
    [types.CLEAR_FILTERS]: filterAdapter.resetFilters,
  }),
});
